import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Auto-refresh + auto-redirect ne 401
let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    const url = original.url || "";

    if (status === 401 && !original.__retried && !url.includes("/auth/")) {
      original.__retried = true;
      try {
        if (!refreshing) {
          refreshing = api.post("/auth/refresh").finally(() => { refreshing = null; });
        }
        await refreshing;
        return api(original);
      } catch (e) {
        // refresh deshtoi -> ridrejto ne login
        if (typeof window !== "undefined" && !window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/portal") && !window.location.pathname.startsWith("/chat-widget")) {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Ndodhi një gabim. Provoni përsëri.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
